/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

// @ts-expect-error
import {LicensingTarget} from '@proto/teamdev/licensing/licensing_target_pb';

export function getOneOfLicensingTargetLimits(target: LicensingTarget)
    : LicensingTarget.ByTime | LicensingTarget.ByMajorVersion {
  const getters = {
    [LicensingTarget.LimitCase.BY_TIME]:          () => target.getByTime(),
    [LicensingTarget.LimitCase.BY_MAJOR_VERSION]: () => target.getByMajorVersion(),
  };
  const whichOne = target.getLimitCase();
  const get = getters[whichOne] || null;
  return get ? get() : null;
}
